import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'u-tooltip-panel',
  templateUrl: './u-tooltip-panel.component.html',
  styleUrls: ['./u-tooltip-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class UTooltipPanelComponent {
  content: string = '';
  template: TemplateRef<any> | null = null;
  templateContext: any = {};

  constructor(private sanitizer: DomSanitizer) {}

  get sanitizedContent(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.content);
  }
}
